// extracted by css-extract-rspack-plugin
export default {"container":"ChatLinks-module__container","btn":"ChatLinks-module__btn","fb":"ChatLinks-module__fb","whatsapp":"ChatLinks-module__whatsapp"};